var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"bg_content"},[_c('div',{staticClass:"toBtnLink",on:{"click":_vm.login}},[_c('div',{staticClass:"login-btn"},[_vm._v("登录")])])])
}
var staticRenderFns = []

export { render, staticRenderFns }